<template>
   <v-overlay :value="OverlaySwitch">
      <v-card light width="500px">
          <v-card-title v-if="resultShow">{{ pageName }}情報変更の最終確認</v-card-title>
          <v-card-title v-if="!resultShow">{{ pageName }}情報</v-card-title>
          <v-card-text v-if="resultShow">{{ pageName }}情報を変更します。</v-card-text>
          <v-card-text v-if="!resultShow">{{ processResult.resultText }}</v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn v-if="resultShow" color="primary" text @click="cancel">戻る</v-btn>
              <v-btn v-if="resultShow" color="primary" text @click.prevent="processing" :disabled="processResult.processing">変更</v-btn>
              <v-btn v-if="!resultShow" color="primary" text @click="cancel">閉じる</v-btn>
          </v-card-actions>
      </v-card>
  </v-overlay>
</template>

<script>
export default {
    props: {
        processResult: {
            result: {
                required: true
            },
            resultText: {
                type: String
            },
            processing: {
                required: true
            }
        },
        OverlaySwitch: {
            type: Boolean,
            required: true
        },
        pageName: {
            type: String
        }
    },
    computed: {
        resultShow () {
            return this.processResult.result === '';
        }
    },
    methods: {
        processing () {
            this.$emit('processing');
        },
        cancel () {
            this.$emit('cancel');
        }
    }
};
</script>
